import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const Remove = (props) => (<Svg fill="none" {...props}>
    <Rect x={0.5} y={0.5} width={31} height={31} rx={15.5} fill="#fff"/>
    <Path d="m20 12-8 8m0-8 8 8" stroke="#393360" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"/>
    <Rect x={0.5} y={0.5} width={31} height={31} rx={15.5} stroke="#E7E9F4"/>
  </Svg>);
export default Remove;
